const address = {
  address: 'Адрес',
  city: 'Город',
  country: 'Страна',
};

export default address;
